import { SET_LANGUAGE } from '../actions/languageActions';

const initialState = {
  selectedLanguage: '', // Default language
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      const language = action.payload;
      return {
        ...state,
        // selectedLanguage: action.payload,
        selectedLanguage: language === 'en' ? '' : language,
      };
    default:
      return state;
  }
};

export default languageReducer;